/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `BadgeType*`'s.
 */
export type BadgeType = BadgeTypeStrong | BadgeTypeOutline | BadgeTypeCombination | BadgeTypeCombinationAlt;

/**
 * The Badge strong type.
 */
export type BadgeTypeStrong = typeof BADGE_TYPE_STRONG;

/**
 * The Badge outline type.
 */
export type BadgeTypeOutline = typeof BADGE_TYPE_OUTLINE;

/**
 * The Badge combination type.
 */
export type BadgeTypeCombination = typeof BADGE_TYPE_COMBINATION;

/**
 * The Badge combination alt type.
 */
export type BadgeTypeCombinationAlt = typeof BADGE_TYPE_COMBINATION_ALT;

/**
 * The Badge strong constant.
 */
export const BADGE_TYPE_STRONG = `strong`;

/**
 * The Badge outline constant.
 */
export const BADGE_TYPE_OUTLINE = `outline`;

/**
 * The Badge combination constant.
 */
export const BADGE_TYPE_COMBINATION = `combination`;

/**
 * The Badge combination alt constant.
 */
export const BADGE_TYPE_COMBINATION_ALT = `combination-alt`;
